import Navbar from './components/Navbar';
import Hero from './components/Hero';
import PlotAnalysis from './components/PlotAnalysis';
import FamousScenes from './components/FamousScenes';
import CharacterMap from './components/CharacterMap';
import HighlightClips from './components/HighlightClips';
import EpisodeRecaps from './components/EpisodeRecaps';
import Faq from './components/Faq';
import About from './components/About';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <PlotAnalysis />
      <FamousScenes />
      <CharacterMap />
      <HighlightClips />
      <EpisodeRecaps />
      <Faq />
      <About />
      <Footer />
      <BackToTop />
    </main>
  );
}